import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
} from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SpriteCacheService } from '../../services/spritecache.service';
import { SpriteController } from '../../../framework/SpriteController';

@Directive({
    selector: '[appImageSprite]',
    standalone: false
})
export class ImageSpriteDirective implements AfterViewInit, OnChanges {
  @Input('appImageSprite') appImageSprite;
  @Input() params;
  @Input() hoverImageName;

  elem;
  @HostBinding('style.background-image') bgIMG: SafeStyle;
  @HostBinding('style.display') bgIMGVisible: SafeStyle = 'none';

  constructor(
    private el: ElementRef,
    private spriteCacheService: SpriteCacheService,
    private sanitizer: DomSanitizer
  ) {
    this.elem = this.el.nativeElement;
  }

  /**
   *
   * @param url image path
   */
  setForImgTag(url) {
    this.bgIMGVisible = '';
    this.elem.src = url;
  }

  /**
   *
   * @param url image path
   */
  setForBGCSS(url) {
    this.bgIMG = this.sanitizer.bypassSecurityTrustStyle('url("' + url + '")');
  }

  ngOnChanges(data) {
    // console.log('ImageSpriteChanges');
    // console.log(data);
    if (data.appImageSprite) {
      if (!data.appImageSprite.firstChange) {
        this.setInitialImage();
      }
    }
  }

  /****
   * To set initial images on load and on mouse leave action
   */
  setInitialImage = (): void => {
    if (this.isImage(this.elem)) {
      this.bgIMGVisible = 'none';
    } else {
      this.bgIMG = this.sanitizer.bypassSecurityTrustStyle('none');
    }

    if (
      this.appImageSprite == null ||
      this.appImageSprite === '' ||
      this.appImageSprite.indexOf('undefined') !== -1
    ) {
      return;
    }
    const imgName = this.appImageSprite;
    // console.log("imgName....", imgName);
    this.assignImage(imgName);
  };

  /**
   * To assign image for the element
   * @path url of the image
   */
  assignImage(imgName) {
    if (this.params == undefined) {
      console.log(imgName);
      return null;
    }
    if (
      this.spriteCacheService.rootContainer[this.params.spriteJSONName] ==
      undefined
    ) {
      console.log(
        '=============================================llllllllllllllllllll======================='
      );

      console.log(imgName);
      console.log(this.params);
      console.log(this.spriteCacheService.rootContainer);
      console.log(this.params.spriteJSONName);
      console.log(
        this.spriteCacheService.rootContainer[this.params.spriteJSONName]
      );
      return null;
    }

    /*console.log("sprite getResult", window["loadQueueItems"], imgName);
   //console.log("sprite getResult", this.params.spriteJSONName);
   //console.log("sprite getResult", window["loadQueueItems"].getResult(this.params.spriteJSONName), imgName);
   window['loadQueueItems'].getResult(this.params.spriteName),
        window['loadQueueItems'].getResult(this.params.spriteJSONName),*/
    // console.log(this.spriteCacheService.rootContainer);
    // console.log(this.params.spriteJSONName);
    if (imgName || imgName.trim() !== '') {
      SpriteController.getImageFromSprite(
        this.spriteCacheService[this.params.spriteContainerName],
        this.spriteCacheService.rootContainer[this.params.spriteName],
        this.spriteCacheService.rootContainer[this.params.spriteJSONName],
        imgName + '.webp',
        this.params.basePath
      ).then((base64Img) => {
        if (this.isImage(this.elem)) {
          this.setForImgTag(base64Img);
        } else {
          this.setForBGCSS(base64Img);
        }
      });
    }
  }

  /***
   * To set hover image in mouse action
   */
  @HostListener('mouseleave')
  setImageOnMouseLeave = (): void => {
    if (this.hoverImageName) {
      this.setInitialImage();
    }
  };
  /****
   * To set initial images on load and on mouse leave action
   */
  @HostListener('mouseenter')
  setImageOnMouseEnter = (): void => {
    if (this.hoverImageName) {
      const imgName = this.hoverImageName;
      this.assignImage(imgName);
    }
  };

  ngAfterViewInit() {
    // console.log("path", this.pathService.getOperatorURL(), this.iconSprite);
    this.setInitialImage();
  }

  isImage(i) {
    return i instanceof HTMLImageElement;
  }
}
